(function () {
  'use strict';

  // ---------- Konfiguration ----------

  // Aktionen: Geschenk ab Schwelle (nach Rabatten), wenn einer der Codes aktiv ist.
  // Unabhaengig vom Standardgeschenk — beide koennen gleichzeitig im Warenkorb liegen.
  const PROMOS = [
    {
      name:      'Influencer',
      codes:     ['INA', 'MAMA', 'LEONIE', 'STEPHANIE', 'MARTINA'],
      giftId:    53432477647115,
      threshold: 20000
    }
  ];

  // Standardgeschenk ab 300 €
  const GIFT_DEFAULT_ID   = 44751172960523;
  const THRESHOLD_DEFAULT = 30000;

  // Zweite Geschenkschwelle. Muss zur Theme-Einstellung
  // cart_free_gift_2_threshold passen — bei Abweichung warnt renderGoal.
  const GIFT_TIER2_ID     = 0;               // Variant-ID, 0 = aus
  const THRESHOLD_TIER2   = 0;               // in Cent, z. B. 50000

  // Geschenke beendeter Aktionen: werden entfernt, nie mehr hinzugefuegt
  const RETIRED_GIFT_IDS  = [
    53274924548363,  // HAUTZEIT
    41460416479425   // HAARZEIT
  ];

  const GIFT_IDS = [GIFT_DEFAULT_ID, GIFT_TIER2_ID]
    .concat(PROMOS.map(p => p.giftId))
    .filter(Boolean);
  const MANAGED_IDS = GIFT_IDS.concat(RETIRED_GIFT_IDS);

  const isCartPage     = window.location.pathname === '/cart';
  const CART_CONTAINER = isCartPage ? '[data-section-type="cart"]' : '#sidebar-cart';
  const SECTION_ID     = isCartPage ? 'main-cart' : 'mini-cart';

  const GOAL_SELECTOR  = '[data-cart-goal]';

  let isSyncing = false, isOwnRender = false, isOwnPaint = false;
  let debounceTimer = null, pendingSync = false, firstSchedule = 0;
  let lastBaseTotal = null, warnedThreshold = false;

  // Eigene Geschenkzeile = verwaltete Variante UND von diesem Skript angelegt.
  // Gekaufte Exemplare derselben Variante bleiben unangetastet.
  function isOwnGift(item) {
    return MANAGED_IDS.includes(item.variant_id)
      && item.properties && item.properties._gift === 'true';
  }

  // ---------- DiscountYard ----------

  function sd() {
    const o = window.StackDiscounts;
    return (o && o.enabled) ? o : null;
  }

  function getActiveCoupons() {
    const o = sd();
    if (o && Array.isArray(o.coupons)) {
      return o.coupons.map(c => String(c).trim().toUpperCase()).filter(Boolean);
    }
    // Fallback: StackDiscounts ist nicht auf jeder Seite geladen
    const raw = document.cookie.split('; ').find(c => c.startsWith('localcoupons='));
    return raw
      ? decodeURIComponent(raw.split('=').slice(1).join('='))
          .split(',').map(c => c.trim().toUpperCase()).filter(Boolean)
      : [];
  }

  // Basis in Cent: der rabattierte Warenkorbwert, den auch der Kunde sieht.
  // Geschenkzeilen stecken darin bereits mit 0,00 € — nichts zusätzlich abziehen.
  // Rückgabe null = "nicht bestimmbar", dann nichts anfassen.
  function getBaseTotal(cart) {
    const o = sd();

    if (!o || getActiveCoupons().length === 0) {
      // Kein Code aktiv: Zeilensumme ohne eigene Geschenke.
      return cart.items
        .filter(i => !isOwnGift(i))
        .reduce((s, i) => s + i.final_line_price, 0);
    }

    if (typeof o.total_value !== 'number') return null;
    return Math.round(o.total_value * 100);
  }

  // Liefert ein Array der Varianten, die im Warenkorb liegen sollen.
  // undefined = "keine Aussage moeglich", leeres Array = "kein Geschenk".
  function getEligibleGiftIds(baseTotal) {
    if (baseTotal === null) return undefined;
    const codes = getActiveCoupons();
    const wanted = [];

    if (baseTotal >= THRESHOLD_DEFAULT) {
      wanted.push(GIFT_DEFAULT_ID);
    }

    PROMOS.forEach(p => {
      const active = p.codes.some(c => codes.includes(c.toUpperCase()));
      if (active && baseTotal >= p.threshold && !wanted.includes(p.giftId)) {
        wanted.push(p.giftId);
      }
    });

    if (GIFT_TIER2_ID && THRESHOLD_TIER2 > 0 && baseTotal >= THRESHOLD_TIER2) {
      wanted.push(GIFT_TIER2_ID);
    }

    console.log('[Gift] Basis:', baseTotal, '| Codes:', codes, '| Ziel:', wanted);
    return wanted;
  }

  // ---------- Fortschrittsanzeige ----------
  //
  // Liquid rendert die Leiste serverseitig aus cart.total_price. Das ist der
  // Rohwert und zählt von DiscountYard eingefügte Geschenkzeilen zum vollen
  // Preis mit. Hier wird nur nachkorrigiert, wenn getBaseTotal() etwas anderes
  // ergibt — also derselbe Wert, auf den auch die Geschenke anspringen.
  // Schwellen, Texte und Marker-Ids kommen aus den data-Attributen.

  function group(value, thousands, decimal, places) {
    const fixed = Math.abs(value).toFixed(places);
    const parts = fixed.split('.');
    const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return places ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    const value = cents / 100;
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => {
      switch (name) {
        case 'amount_no_decimals': return group(value, ',', '.', 0);
        case 'amount_with_comma_separator': return group(value, '.', ',', 2);
        case 'amount_no_decimals_with_comma_separator': return group(value, '.', ',', 0);
        default: return group(value, ',', '.', 2);
      }
    });
  }

  // Haengt einen Text an und uebersetzt {br} in einen echten Zeilenumbruch.
  function append(node, str) {
    String(str).split('{br}').forEach((chunk, i) => {
      if (i) node.appendChild(document.createElement('br'));
      if (chunk) node.appendChild(document.createTextNode(chunk));
    });
  }

  function renderGoal(baseTotal) {
    if (baseTotal === null || baseTotal === undefined) return;

    const root = document.querySelector(GOAL_SELECTOR);
    if (!root) return;

    const raw    = Number(root.getAttribute('data-value'));
    const max    = Number(root.getAttribute('data-max'));
    const format = root.getAttribute('data-money-format');

    let tiers = [];
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); }
    catch (e) { console.warn('[Goal] data-tiers nicht lesbar:', e); return; }

    const gift1 = tiers.find(t => t.id === 'gift1');
    if (!warnedThreshold && gift1 && gift1.at !== THRESHOLD_DEFAULT) {
      warnedThreshold = true;
      console.warn('[Goal] Theme-Einstellung (' + gift1.at + ') und THRESHOLD_DEFAULT (' +
                   THRESHOLD_DEFAULT + ') laufen auseinander.');
    }
    const gift2 = tiers.find(t => t.id === 'gift2');
    if (gift2 && gift2.at !== THRESHOLD_TIER2) {
      console.warn('[Goal] Schwelle 2 im Theme (' + gift2.at + ') und THRESHOLD_TIER2 (' +
                   THRESHOLD_TIER2 + ') laufen auseinander.');
    }

    // Liquid liegt bereits richtig — nichts anfassen.
    if (baseTotal === raw) return;
    if (root.getAttribute('data-corrected') === String(baseTotal)) return;

    const message = root.querySelector('[data-cart-goal-message]');
    const fill    = root.querySelector('[data-cart-goal-fill]');
    const rail    = fill && fill.parentElement;
    if (!message || !fill) return;

    isOwnPaint = true;

    // Marker: erreicht = volle Deckkraft
    tiers.forEach(tier => {
      const marker = root.querySelector('[data-tier="' + tier.id + '"]');
      if (marker) marker.classList.toggle('is-won', baseTotal >= tier.at);
    });

    // Text
    const next = tiers.find(tier => baseTotal < tier.at) || null;
    message.textContent = '';

    if (!next) {
      append(message, root.getAttribute('data-text-done') || '');
    } else {
      const template = (root.getAttribute('data-text-pending') || '')
        .replace('{label}', next.label || '');
      const parts = template.split('{amount}');
      append(message, parts[0] || '');
      const amount = document.createElement('span');
      amount.className = 'CartGoal__Amount';
      amount.textContent = formatMoney(next.at - baseTotal, format);
      message.appendChild(amount);
      append(message, parts[1] || '');
    }

    // Skala
    const percent = max > 0
      ? Math.max(0, Math.min(100, Math.round((baseTotal / max) * 100)))
      : 100;
    fill.style.width = percent + '%';
    if (rail) rail.setAttribute('aria-valuenow', String(percent));

    root.setAttribute('data-corrected', String(baseTotal));
    console.log('[Goal] korrigiert:', raw, '→', baseTotal, '|', percent + '%');
    setTimeout(() => { isOwnPaint = false; }, 0);
  }

  // ---------- Sync ----------

  async function syncGiftProduct() {
    if (isSyncing) { pendingSync = true; return; }
    isSyncing = true;

    try {
      const cart      = await fetch('/cart.js').then(r => r.json());
      const baseTotal = getBaseTotal(cart);

      lastBaseTotal = baseTotal;
      renderGoal(baseTotal);

      const wanted = getEligibleGiftIds(baseTotal);

      if (wanted === undefined) {
        console.warn('[Gift] Rabattwert nicht bestimmbar – keine Änderung.');
        return;
      }

      const present  = cart.items.filter(isOwnGift);
      const toRemove = present.filter(i => !wanted.includes(i.variant_id));
      const toAdd    = wanted.filter(id => !present.some(i => i.variant_id === id));

      console.log('[Gift] im Cart:', present.map(i => i.variant_id),
                  '| entfernen:', toRemove.map(i => i.variant_id), '| hinzu:', toAdd);

      if (!toRemove.length && !toAdd.length) return;

      for (const item of toRemove) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      }

      if (toAdd.length) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: toAdd.map(id => ({ id, quantity: 1, properties: { _gift: 'true' } }))
          })
        });
      }

      await new Promise(r => setTimeout(r, 600));
      await reRender();

    } catch (e) {
      console.error('[Gift] Fehler:', e);
    } finally {
      isSyncing = false;
      if (pendingSync) { pendingSync = false; scheduleSync(300); }
    }
  }

  // ---------- Rendering ----------

  async function reRender() {
    isOwnRender = true;
    try {
      const html = await fetch(`/cart?section_id=${SECTION_ID}&timestamp=${Date.now()}`)
                        .then(r => r.text());
      const doc     = new DOMParser().parseFromString(html, 'text/html');
      const fresh   = doc.querySelector(CART_CONTAINER);
      const current = document.querySelector(CART_CONTAINER);
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      if (sd() && typeof sd().initStackDiscounts === 'function') {
        sd().initStackDiscounts();
      }
      // Das frische Markup trägt wieder den Rohwert — erneut korrigieren.
      renderGoal(lastBaseTotal);
    } finally {
      setTimeout(() => { isOwnRender = false; }, 800);
    }
  }

  // ---------- Trigger ----------

  function scheduleSync(delay = 300) {
    const now = Date.now();
    if (!firstSchedule) firstSchedule = now;
    if (now - firstSchedule > 2000) {          // Timer nicht endlos zurücksetzen
      clearTimeout(debounceTimer);
      firstSchedule = 0;
      syncGiftProduct();
      return;
    }
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => { firstSchedule = 0; syncGiftProduct(); }, delay);
  }

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const url    = args[0]?.toString() || '';
    const result = await originalFetch.apply(this, args);
    if (url.includes(`/cart?section_id=${SECTION_ID}`) && !isOwnRender) scheduleSync();
    return result;
  };

  function observeCart() {
    const target = document.querySelector(CART_CONTAINER);
    if (!target) return setTimeout(observeCart, 500);
    new MutationObserver(() => {
      if (!isOwnRender && !isOwnPaint) scheduleSync(500);
    }).observe(target, { childList: true, subtree: true, characterData: true });
  }

  observeCart();
  syncGiftProduct();

  window.__giftSync = syncGiftProduct;
})();